<ion-content [class.app]="native">

  <!-- Header -->

  <div class="header">
    <a href="/" class="logo" title="iBucket">
      <img src="assets/svg/index-logo.svg" width="100%" height="auto" alt="iBucket">
    </a>
    <a class="login" title="{{ 'IndexApp' | translate }}" rel="nofollow" (click)="openLogin()">
      {{ 'IndexApp' | translate }}
    </a>
    <div class="content">
      <div class="avatars left">
        <img src="assets/imgs/index-avatar1.png" width="80" height="80" class="first" alt="Avatar">
        <img src="assets/imgs/index-avatar2.png" width="70" height="70" class="second" alt="Avatar">
        <img src="assets/imgs/index-avatar3.png" width="60" height="60" class="third" alt="Avatar">
      </div>
      <div class="avatars right">
        <img src="assets/imgs/index-avatar4.png" width="80" height="80" class="first" alt="Avatar">
        <img src="assets/imgs/index-avatar5.png" width="70" height="70" class="second" alt="Avatar">
        <img src="assets/imgs/index-avatar6.png" width="60" height="60" class="third" alt="Avatar">
      </div>
      <img src="assets/svg/index-rating.svg" width="124" height="28" alt="4.8 Rating">
      <h1>{{ 'IndexHeading' | translate }}</h1>
      <div class="intro">
        {{ 'IndexIntro' | translate }}
      </div>
      <a class="button" [class.spinner]="spinner" rel="nofollow" (click)="openCreate()">
        {{ 'IndexCreate' | translate }}
      </a>
      <div class="buttons">
        <a href="https://apps.apple.com/{{language}}/app/id864052715" target="_blank" title="App Store" (click)="setEvents('index_apple')">
          <img src="assets/svg/index-apple-header.svg" width="145" height="40" alt="App Store">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.kaimallie.ibucket&hl={{language}}" target="_blank" title="Google Play" (click)="setEvents('index_google')">
          <img src="assets/svg/index-google-header.svg" width="145" height="40" alt="Google Play">
        </a>
      </div>
    </div>
    <div class="images"></div>
  </div>

  <!-- Columns -->

  <div class="features">
    <div class="feature blue">
      <h3>{{ 'IndexGoals' | translate }}</h3>
      <div class="text">{{ 'IndexGoalsText' | translate }}</div>
      <img src="assets/imgs/index-goals.png" width="100%" height="auto" alt="{{ 'IndexGoals' | translate }}">
    </div>
    <div class="feature orange">
      <h3>{{ 'IndexTrips' | translate }}</h3>
      <div class="text">{{ 'IndexTripsText' | translate }}</div>
      <img src="assets/imgs/index-trips.png" width="100%" height="auto" alt="{{ 'IndexTrips' | translate }}">
    </div>
    <div class="feature green">
      <h3>{{ 'IndexPlaces' | translate }}</h3>
      <div class="text">{{ 'IndexPlacesText' | translate }}</div>
      <img src="assets/imgs/index-places.png" width="100%" height="auto" alt="{{ 'IndexPlaces' | translate }}">
    </div>
    <div class="feature red">
      <h3>{{ 'IndexFriends' | translate }}</h3>
      <div class="text">{{ 'IndexFriendsText' | translate }}</div>
      <img src="assets/imgs/index-friends.png" width="100%" height="auto" alt="{{ 'IndexFriends' | translate }}">
    </div>
    <div class="feature purple">
      <h3>{{ 'IndexPassport' | translate }}</h3>
      <div class="text">{{ 'IndexPassportText' | translate }}</div>
      <img src="assets/imgs/index-passport.png" width="100%" height="auto" alt="{{ 'IndexPassport' | translate }}">
    </div>
    <div class="feature yellow">
      <h3>{{ 'IndexJournal' | translate }}</h3>
      <div class="text">{{ 'IndexJournalText' | translate }}</div>
      <img src="assets/imgs/index-journal.png" width="100%" height="auto" alt="{{ 'IndexJournal' | translate }}">
    </div>
  </div>

  <!-- Footer -->

  <div class="footer">
    <h2>{{ 'IndexPayoff' | translate }}</h2>
    <div class="download">{{ 'IndexDownload' | translate }}</div>
    <img src="assets/svg/index-featured.svg" width="145" height="50" alt="">
    <div class="buttons">
      <a href="https://apps.apple.com/{{language}}/app/id864052715" target="_blank" title="App Store" (click)="setEvents('index_apple')">
        <img src="assets/svg/index-apple.svg" width="160" height="44" alt="App Store">
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.kaimallie.ibucket&hl={{language}}" target="_blank" title="Google Play" (click)="setEvents('index_google')">
        <img src="assets/svg/index-google.svg" width="160" height="44" alt="Google Play">
      </a>
      <a target="_blank" title="Web Browser" rel="nofollow" (click)="setEvents('index_web');openCreate()">
        <img src="assets/svg/index-browser.svg" width="160" height="44" alt="Web Browser">
      </a>
    </div>
    <div class="flags">
      <a href="/" title="English" (click)="setEvents('index_en')">
        <img src="assets/svg/index-en.svg" width="20" height="20" alt="English">
      </a>
      <a href="/nl" title="Nederlands" (click)="setEvents('index_nl')">
        <img src="assets/svg/index-nl.svg" width="20" height="20" alt="Nederlands">
      </a>
      <a href="/de" title="Deutsch" (click)="setEvents('index_de')">
        <img src="assets/svg/index-de.svg" width="20" height="20" alt="Deutsch">
      </a>
      <a href="/fr" title="Français" (click)="setEvents('index_fr')">
        <img src="assets/svg/index-fr.svg" width="20" height="20" alt="Français">
      </a>
      <a href="/it" title="Italiano" (click)="setEvents('index_it')">
        <img src="assets/svg/index-it.svg" width="20" height="20" alt="Italiano">
      </a>
      <a href="/es" title="Español" (click)="setEvents('index_es')">
        <img src="assets/svg/index-es.svg" width="20" height="20" alt="Español">
      </a>
      <a href="/pt" title="Português" (click)="setEvents('index_pt')">
        <img src="assets/svg/index-pt.svg" width="20" height="20" alt="Português">
      </a>
    </div>
    <div class="links">
      <a href="/help" title="{{ 'Help' | translate }}" (click)="setEvents('index_help')">
        {{ 'Help' | translate }}
      </a>
      <a href="/press" title="{{ 'Press' | translate }}" (click)="setEvents('index_press')">
        {{ 'Press' | translate }}
      </a>
      <a href="/privacy" title="{{ 'Privacy' | translate }}" (click)="setEvents('index_privacy')">
        {{ 'Privacy' | translate }}
      </a>
      <a href="/terms" title="{{ 'Terms' | translate }}" (click)="setEvents('index_terms')">
        {{ 'Terms' | translate }}
      </a>
    </div>
  </div>

</ion-content>
